export class LocalLogModel {
  logType?: string;
  logDate?: Date;
  message?: string;
}
